import { createSelector } from '@reduxjs/toolkit';

export const getTabsState = (state) => state.tabs;
export const getTabState = (state) => state.tab;

export const getTabs = createSelector(getTabsState, (tabsState) => tabsState.data);
